import React from 'react';
import { Box, Typography } from '@heycater/design-system';
import { useMediaQuery } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { useQualification } from 'qualification/context';
import useLocalizedFieldName from 'shared/hooks/useLocalizedFieldName';

function QuestionHeader({ questionContent, child }) {
  const { localizedAttributeName } = useLocalizedFieldName();
  const { state } = useQualification();
  const { t } = useTranslation('qualification');
  const mobile = useMediaQuery((theme) => theme.breakpoints.down('xs'));
  let title = questionContent[localizedAttributeName('title')];
  let mobileSubtitle =
    questionContent[localizedAttributeName('mobileSubtitle')];
  let subtitle = questionContent[localizedAttributeName('subtitle')];

  if (
    state.status === 'answering' &&
    state.qualification.step.id.includes('tier-')
  ) {
    title = t('customerTier.title');
    mobileSubtitle = t('customerTier.title');
    subtitle = t('customerTier.subtitle');
  }

  return (
    <Header>
      {title && (
        <Typography variant={child ? 'h6' : 'h4'} px={3}>
          {title}
        </Typography>
      )}

      {mobile && mobileSubtitle ? (
        <Box width={mobile ? '95%' : '73%'} display="inline-block" pt={2}>
          <Typography variant="caption">{mobileSubtitle}</Typography>
        </Box>
      ) : (
        subtitle && (
          <Box width={mobile ? '95%' : '73%'} display="inline-block" pt={2}>
            <Typography variant="caption">{subtitle}</Typography>
          </Box>
        )
      )}
    </Header>
  );
}

const Header = styled.header`
  text-align: center;
  margin-bottom: ${(props) => props.theme.spacing(2)}px;
`;

export default QuestionHeader;
